// extracted by mini-css-extract-plugin
export default {"multilineLabel":"styles---multilineLabel---gQ3FC"};